import React, {useState} from "react";
import axios from "config/axiosConfig";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";

export default function CreateDummy() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [form, setForm] = useState({
        email: `dummy_${Math.random().toString(36).substring(2, 10)}@example.com`,
        nickname: "",
        roles: ["CONSUMER"],
        userState: "INIT",
        
        // Consumer
        consumerStatus: "재직중",
        consumerExperienceYears: 0,
        consumerCurrentIndustry: "",
        consumerCurrentRole: "",
        consumerTargetRole: "",
        consumerTargetAreas: [],
        consumerCurrentCompanyTypes: [],
        consumerTargetIndustries: [],
        consumerTargetCompanyTypes: [],
        consumerTargetSkills: [],

        // Provider
        providerStatus: "재직중",
        providerExperienceYears: 0,
        providerCurrentIndustry: "",
        providerCurrentRole: "",
        providerServiceSkills: [],
        providerServiceYears: "JUNIOR",
        providerCurrentCompanyTypes: [],
        providerServiceIndustries: [],
        providerServiceCompanyTypes: [],
        providerServiceRoles: [],
        providerServiceAreas: []
    });

    const jobFamilies = [
        {
            name: "개발/엔지니어링",
            roles: ["백엔드 개발자", "프론트엔드 개발자", "모바일 개발자", "풀스택 개발자", "DevOps 엔지니어", "QA 엔지니어"],
            industries: ["핀테크", "B2B SaaS", "인터넷 서비스", "클라우드", "보안/사이버보안", "엔터프라이즈 IT"],
            skills: ["SQL", "Python", "API 이해", "REST API", "클라우드 이해(AWS)", "Git", "JIRA", "Notion"]
        },
        {
            name: "데이터/AI",
            roles: ["데이터 분석가", "비즈니스 분석가(BA)", "데이터 사이언티스트", "ML 엔지니어"],
            industries: ["AI/데이터", "빅데이터", "블록체인", "핀테크", "이커머스"],
            skills: ["SQL", "Python", "R", "Tableau", "Power BI", "Looker", "데이터 시각화", "통계 기초", "회귀 분석", "머신러닝 기초"]
        },
        {
            name: "기획/프로덕트",
            roles: ["프로덕트 매니저(PM)", "프로덕트 오너(PO)", "서비스 기획자", "전략기획"],
            industries: ["플랫폼", "B2C SaaS", "이커머스", "모빌리티 플랫폼", "여행/OTA", "핀테크"],
            skills: ["Figma", "UX 리서치", "와이어프레임 설계", "PRD 작성", "문제 정의", "KPI 설계", "OKR 수립", "의사결정 프레임워크"]
        },
        {
            name: "마케팅/광고",
            roles: ["그로스 마케터", "퍼포먼스 마케터", "브랜드 마케터", "콘텐츠 마케터", "CRM 마케터", "마케팅 매니저"],
            industries: ["광고/마케팅", "이커머스", "리테일", "뷰티", "패션", "소비재(FMCG)", "콘텐츠/미디어"],
            skills: ["GA4", "Amplitude", "Mixpanel", "A/B 테스트 설계", "퍼널 분석", "리텐션 분석", "콘텐츠 기획", "카피라이팅", "브랜드 전략"]
        },
        {
            name: "디자인",
            roles: ["UI/UX 디자이너", "프로덕트 디자이너", "브랜드 디자이너", "아트 디렉터"],
            industries: ["플랫폼", "게임", "콘텐츠/미디어", "이커머스", "뷰티"],
            skills: ["Figma", "UX 리서치", "사용자 인터뷰", "와이어프레임 설계", "브랜드 전략", "스토리텔링"]
        },
        {
            name: "영업/사업개발",
            roles: ["세일즈", "세일즈 매니저", "사업개발(BD)", "파트너십 매니저", "MD", "카테고리 매니저"],
            industries: ["이커머스", "리테일", "식품/F&B", "여행/OTA", "부동산/프롭테크", "유통"],
            skills: ["세일즈 파이프라인 관리", "협업 커뮤니케이션", "프레젠테이션", "시장 분석", "경쟁사 분석", "사업 모델링"]
        }
    ];

    const allRoles = [...new Set(jobFamilies.flatMap(f => f.roles))].sort();
    const allIndustries = [...new Set(jobFamilies.flatMap(f => f.industries))].sort();
    const allSkills = [...new Set(jobFamilies.flatMap(f => f.skills))].sort();

    const careerStatuses = ["재직중", "구직중", "휴직중", "재학중"];
    const companyTypes = ["대기업", "중견중소기업", "스타트업", "공기업/공공기관", "비영리기구", "외국계기업"];
    const areas = ["모의 면접", "이력서 피드백", "포트폴리오 피드백", "커리어 방향성", "직무 핏", "커리어 정보", "산업군 정보"];

    const handleInputChange = (e) => {
        const {name, value} = e.target;
        setForm({...form, [name]: value});
    };

    const handleMultiSelectChange = (e, field) => {
        const value = Array.from(e.target.selectedOptions, option => option.value);
        setForm({...form, [field]: value});
    };

    const handleCheckboxChange = (e) => {
        const {value, checked} = e.target;
        let newRoles = [...form.roles];
        if (checked) {
            newRoles.push(value);
        } else {
            newRoles = newRoles.filter(r => r !== value);
        }
        setForm({...form, roles: newRoles});
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        const submissionForm = {
            ...form
        };

        axios.post("/admin/v1/members/manual-dummy", submissionForm)
            .then((res) => {
                toast.success("회원이 생성되었습니다.");
                window.open(`/page/users/detail?userId=${res.data}`, "_blank");
            })
            .catch(err => {
                console.error(err);
                toast.error("회원 생성에 실패했습니다.");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">회원관리 > 더미 회원 수동 생성</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <form onSubmit={handleSubmit}>
                                <div className="card card-primary">
                                    <div className="card-header">
                                        <h3 className="card-title">기본 정보</h3>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>이메일</label>
                                                    <input type="email" name="email" className="form-control" value={form.email} onChange={handleInputChange} required />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>닉네임 (비워두면 자동 생성)</label>
                                                    <input type="text" name="nickname" className="form-control" value={form.nickname} onChange={handleInputChange} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>권한</label>
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox" value="CONSUMER" checked={form.roles.includes("CONSUMER")} onChange={handleCheckboxChange} />
                                                        <label className="form-check-label">수요자 (CONSUMER)</label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox" value="PROVIDER" checked={form.roles.includes("PROVIDER")} onChange={handleCheckboxChange} />
                                                        <label className="form-check-label">공급자 (PROVIDER)</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>회원 상태</label>
                                                    <select name="userState" className="form-control" value={form.userState} onChange={handleInputChange}>
                                                        <option value="INIT">유저 생성</option>
                                                        <option value="PROVIDER_AUTHORIZED">공급자 승인 완료</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {form.roles.includes("CONSUMER") && (
                                    <div className="card card-info">
                                        <div className="card-header">
                                            <h3 className="card-title">구매자 커리어 정보</h3>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>커리어 상태</label>
                                                        <select name="consumerStatus" className="form-control" value={form.consumerStatus} onChange={handleInputChange}>
                                                            {careerStatuses.map(status => (
                                                                <option key={status} value={status}>{status}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>경력 연차</label>
                                                        <input type="number" name="consumerExperienceYears" className="form-control" value={form.consumerExperienceYears} onChange={handleInputChange} />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>목표 직무</label>
                                                        <select name="consumerTargetRole" className="form-control" value={form.consumerTargetRole} onChange={handleInputChange}>
                                                            <option value="">선택하세요</option>
                                                            {allRoles.map(role => (
                                                                <option key={role} value={role}>{role}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>현재/최근 산업</label>
                                                        <select name="consumerCurrentIndustry" className="form-control" value={form.consumerCurrentIndustry} onChange={handleInputChange}>
                                                            <option value="">선택 안 함 (신입)</option>
                                                            {allIndustries.map(industry => (
                                                                <option key={industry} value={industry}>{industry}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>현재/최근 직무</label>
                                                        <select name="consumerCurrentRole" className="form-control" value={form.consumerCurrentRole} onChange={handleInputChange}>
                                                            <option value="">선택 안 함 (신입)</option>
                                                            {allRoles.map(role => (
                                                                <option key={role} value={role}>{role}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>원하는 서비스 영역 (다중 선택)</label>
                                                        <select multiple className="form-control" value={form.consumerTargetAreas} onChange={(e) => handleMultiSelectChange(e, "consumerTargetAreas")}>
                                                            {areas.map(area => (
                                                                <option key={area} value={area}>{area}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>현재 회사 유형 (다중 선택)</label>
                                                        <select multiple className="form-control" value={form.consumerCurrentCompanyTypes} onChange={(e) => handleMultiSelectChange(e, "consumerCurrentCompanyTypes")}>
                                                            {companyTypes.map(type => (
                                                                <option key={type} value={type}>{type}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>목표 산업 (다중 선택)</label>
                                                        <select multiple className="form-control" value={form.consumerTargetIndustries} onChange={(e) => handleMultiSelectChange(e, "consumerTargetIndustries")}>
                                                            {allIndustries.map(industry => (
                                                                <option key={industry} value={industry}>{industry}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>목표 회사 유형 (다중 선택)</label>
                                                        <select multiple className="form-control" value={form.consumerTargetCompanyTypes} onChange={(e) => handleMultiSelectChange(e, "consumerTargetCompanyTypes")}>
                                                            {companyTypes.map(type => (
                                                                <option key={type} value={type}>{type}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>얻고 싶은 스킬 (다중 선택)</label>
                                                        <select multiple className="form-control" value={form.consumerTargetSkills} onChange={(e) => handleMultiSelectChange(e, "consumerTargetSkills")}>
                                                            {allSkills.map(skill => (
                                                                <option key={skill} value={skill}>{skill}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {form.roles.includes("PROVIDER") && (
                                    <div className="card card-success">
                                        <div className="card-header">
                                            <h3 className="card-title">판매자 커리어 정보</h3>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>경력 연차</label>
                                                        <input type="number" name="providerExperienceYears" className="form-control" value={form.providerExperienceYears} onChange={handleInputChange} />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>현재 산업</label>
                                                        <select name="providerCurrentIndustry" className="form-control" value={form.providerCurrentIndustry} onChange={handleInputChange}>
                                                            <option value="">선택하세요</option>
                                                            {allIndustries.map(industry => (
                                                                <option key={industry} value={industry}>{industry}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>현재 직무</label>
                                                        <select name="providerCurrentRole" className="form-control" value={form.providerCurrentRole} onChange={handleInputChange}>
                                                            <option value="">선택하세요</option>
                                                            {allRoles.map(role => (
                                                                <option key={role} value={role}>{role}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>현재 회사 유형 (다중 선택)</label>
                                                        <select multiple className="form-control" value={form.providerCurrentCompanyTypes} onChange={(e) => handleMultiSelectChange(e, "providerCurrentCompanyTypes")}>
                                                            {companyTypes.map(type => (
                                                                <option key={type} value={type}>{type}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>핵심 스킬/강점 (다중 선택)</label>
                                                        <select multiple className="form-control" value={form.providerServiceSkills} onChange={(e) => handleMultiSelectChange(e, "providerServiceSkills")}>
                                                            {allSkills.map(skill => (
                                                                <option key={skill} value={skill}>{skill}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>서비스 제공 연차 레벨</label>
                                                        <select name="providerServiceYears" className="form-control" value={form.providerServiceYears} onChange={handleInputChange}>
                                                            <option value="JUNIOR">주니어</option>
                                                            <option value="MID">미들</option>
                                                            <option value="SENIOR">시니어</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>제공 가능한 서비스 영역 (다중 선택)</label>
                                                        <select multiple className="form-control" value={form.providerServiceAreas} onChange={(e) => handleMultiSelectChange(e, "providerServiceAreas")}>
                                                            {areas.map(area => (
                                                                <option key={area} value={area}>{area}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>서비스 가능 직무 (다중 선택)</label>
                                                        <select multiple className="form-control" value={form.providerServiceRoles} onChange={(e) => handleMultiSelectChange(e, "providerServiceRoles")}>
                                                            {allRoles.map(role => (
                                                                <option key={role} value={role}>{role}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>서비스 가능 산업 (다중 선택)</label>
                                                        <select multiple className="form-control" value={form.providerServiceIndustries} onChange={(e) => handleMultiSelectChange(e, "providerServiceIndustries")}>
                                                            {allIndustries.map(industry => (
                                                                <option key={industry} value={industry}>{industry}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>서비스 제공 가능 회사 유형 (다중 선택)</label>
                                                        <select multiple className="form-control" value={form.providerServiceCompanyTypes} onChange={(e) => handleMultiSelectChange(e, "providerServiceCompanyTypes")}>
                                                            {companyTypes.map(type => (
                                                                <option key={type} value={type}>{type}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div className="card-footer" style={{textAlign: 'center'}}>
                                    <button type="submit" className="btn btn-primary btn-lg" disabled={loading}>
                                        {loading ? "생성 중..." : "더미 회원 생성 완료"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}
